<section>
  <header>
    <h1 auto="eval-step-1-title">Evaluating Phase</h1>
  </header>
  <div class="information-container">
    <div>
      <p><strong>Judge Success of Annual Plan</strong></p>
      <p>
        In the Determine Impacts of Critical Initiatives subphase, you identified the findings from the evaluation of individual critical initiatives in relation to one another.
      </p>
      <p>
        Based on a thorough exploration of outcomes, write a summary of the findings regarding the effectiveness of the Annual Improvement Plan. How did the work related to the critical initiatives connect to any progress toward achieving long-term objectives?
      </p>
    </div>
  </div>
  <div class="explanation-margin">
    <div class="download-guide-container">
      <img class="book-icon pointer" src="assets/images/download-guide-icon.svg" alt="book-icon" (click)="openGuide()">
      <span class="download-tagline pointer" (click)="openGuide()">Download the guide</span> to learn more about <strong>Judging Success of Annual Plan</strong>.
    </div>
  </div>

  <div>
    <h3>Overall Findings</h3>
  </div>
  <app-rich-content placeholderText="Enter findings here"
                    [content]="impact"
                    [maxContentLength]="MAX_IMPACT_LENGTH"
                    [isReadOnly]="isEditItemDisabled"
                    (contentUpdate)="updateImpact($event)"
                    [heightOverride]="150"
  >
  </app-rich-content>

  <div class="flex-right-left grid-seperator">
    <h3>Attachments</h3>
    <button auto="upload-files-btn" *ngIf="!isEditItemDisabled" class="btn btn-primary" (click)="onClickUploadFiles()">Attach Files</button>
  </div>
  <p-table auto="upload-table" [value]="resources"
           styleClass="priorities-table rounded-zebra-table"
           selectionMode="single"
           (onRowSelect)="onClickResource($event.data)">
    <ng-template pTemplate="emptymessage">
      <tr>
        <td [colSpan]="resourcesColWidth" class="ui-table-empty-message">
          <div class="no-attachments-container">
            <img src="assets/images/attachment-icon-red.svg">
            <h4>No Attachments Found.</h4>
            <p>When you add Attachments they will be listed here.</p>
          </div>

        </td>
      </tr>
    </ng-template>
    <ng-template pTemplate="header">
      <tr>
        <th class="title-column">Attachment Name</th>
        <th>Description</th>
        <th class="actions-column" *ngIf="!isEditItemDisabled && !isDeleteItemDisabled">
          Actions
        </th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-attachment>
      <tr [pSelectableRow]="attachment">
        <td class="title-column">
          <div class='attachment-pointer'>
            <img class="attachment-icon" [src]="iconImageSrc(attachment)"
                 tooltipStyleClass="strategies-tooltip"
                 [alt]="altText(attachment)"
                 [pTooltip]="altText(attachment)">
            {{attachment.name}}
          </div>
        </td>
        <td>
          <div class="attachment-pointer">
            {{attachment.description}}
          </div>
        </td>
        <td class="actions-column" *ngIf="!isEditItemDisabled && !isDeleteItemDisabled">
          <button auto="upload-edit-btn" class="fa fa-pencil pointer" pTooltip="Edit Item" tooltipStyleClass="strategies-tooltip"
                  [disabled]="isEditItemDisabled" (click)="onClickEditAttachment(attachment)">
          </button>
          <button auto="upload-delete-btn" [attr.attachment]="attachment" class="fa fa-trash pointer" pTooltip="Delete Item"
                  tooltipStyleClass="strategies-tooltip"
                  [disabled]="isDeleteItemDisabled" (click)="onClickDeleteItem(attachment, attachment.name)">
          </button>
        </td>
      </tr>
    </ng-template>
  </p-table>
</section>

<app-attachment-upload-modal #attachmentUploadModal
                             [strategyId]="strategyId"
                             (resourceEdit)="editResource($event)"
                             (resourceCreated)="refetchResources()"
                             (resourcesChange)="refetchResources()"></app-attachment-upload-modal>

<p-dialog #confirmDeleteDialog styleClass="strategies-confirm-dialog" [modal]="true" [closable]="false"
          appendTo="body">
  <p-header>
    <img src="assets/images/exclamation.svg" alt="Alert">
    <span class="dialog-title">Are You Sure?</span>
  </p-header>
  <div>Are you sure you want to delete {{ itemLabel }}?<br/></div>
  <p-footer>
    <button auto="upload-delete-cancel-btn" class="btn btn-alt" type="button" pButton label="Cancel"
            (click)="confirmDeleteDialog.visible = false">
    </button>
    <button auto="upload-delete-delete-btn" class="btn" type="button" pButton label="Delete"
            (click)="onConfirmDeleteDialogAccept()"></button>
  </p-footer>
</p-dialog>

